import React from 'react';
export function HeroSection() {
  return <section className="relative w-full bg-gradient-to-r from-light to-warm overflow-hidden py-10 lg:py-32 px-4 sm:px-6 lg:px-8" data-id="element-92">
      <div className="max-w-7xl mx-auto flex flex-col lg:grid lg:grid-cols-2 gap-6 items-center" data-id="element-93">
        {/* Title - always first */}
        <div className="flex flex-col items-center text-center lg:items-center lg:text-center space-y-6 z-10 order-1" data-id="element-94">
          <span className="inline-block px-4 py-1.5 rounded-full bg-white/40 text-dark font-semibold text-sm tracking-wide backdrop-blur-sm" data-id="element-95">
            Academia de PsihoMedicină
          </span>
          <h1 className="text-5xl md:text-5xl lg:text-6xl font-serif font-bold text-dark leading-tight lg:leading-[1.4]" data-id="element-96">
            Înțelege-ți corpul.
            <br data-id="element-97" />
            Vindecă-ți mintea.
            <br data-id="element-98" />
            Trăiește echilibrat.
          </h1>
        </div>

        {/* Image - second on mobile, right column on desktop */}
        <div className="relative z-10 flex justify-center order-2 lg:row-span-2 mt-6 lg:mt-0 w-full" data-id="element-99">
          <div className="relative w-64 h-80 sm:w-80 sm:h-[420px] md:w-96 md:h-[500px] lg:h-[600px] rounded-t-full rounded-b-2xl overflow-hidden shadow-2xl border-4 border-white/50" data-id="element-100">
            <img src="https://cdn.magicpatterns.com/uploads/jhbAP4yzHgqovyFrn6d67J/28.png" alt="Dr. Cornelia Tianu - Academia de PsihoMedicină" className="w-full h-full object-cover object-center" data-id="element-101" />
            <div className="absolute inset-0 bg-primary/10 mix-blend-overlay" data-id="element-102"></div>
          </div>
        </div>

        {/* Subtitle + CTA - third on mobile, below title on desktop */}
        <div className="flex flex-col items-center text-center space-y-4 z-10 order-3" data-id="element-103">
          <p className="text-lg md:text-xl lg:text-2xl text-body max-w-xl leading-relaxed" data-id="element-104">
            Medicina clasică, terapiile alternative și psihoterapia într-un
            singur loc, pentru persoanele care funcționează perfect în exterior,
            dar în interior sunt epuizate.
          </p>
          <div className="flex flex-col items-center space-y-3 pt-4" data-id="element-105">
            <a href="https://api.leadconnectorhq.com/widget/bookings/cmi-dr-cornelia-tianu-39b19d4e-46bc-4f77-b746-6d1dddacfb09" className="rounded-full bg-primary text-white font-semibold px-8 py-4 hover:bg-[#5A1D5F] transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 duration-200 inline-block" data-id="element-106">
              Rezervă Sesiunea de Consultanță CADOU
            </a>
            <p className="text-sm text-dark/80 font-medium" data-id="element-107">
              Fără promisiuni goale. Fără rețete miraculoase.
              <br className="lg:hidden" data-id="element-108" />
              <span className="hidden lg:inline" data-id="element-109"> </span>
              Cu claritate și blândețe.
            </p>
          </div>
        </div>
      </div>
    </section>;
}